// extracted by mini-css-extract-plugin
module.exports = {"styledErrorMessageRoot":"VZV2MYoh","showBorder":"I70UgyDJ"};